import React from "react";

interface DecorativeProps {
  type?: "corners" | "divider" | "line";
  className?: string;
}

export const DecorativeElement: React.FC<DecorativeProps> = ({
  type = "corners",
  className = "",
}) => {
  if (type === "corners") {
    return (
      <div className={`relative ${className}`}>
        <div className="decorative-corner top-left" />
        <div className="decorative-corner top-right" />
        <div className="decorative-corner bottom-left" />
        <div className="decorative-corner bottom-right" />
      </div>
    );
  }

  if (type === "divider") {
    return <div className={`section-divider ${className}`} />;
  }

  return <div className={`decorative-line ${className}`} />;
};

interface FloatingElementProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

export const FloatingElement: React.FC<FloatingElementProps> = ({
  children,
  className = "",
  delay = 0,
}) => {
  return (
    <div
      className={`float-animation ${className}`}
      style={{ animationDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

export const GradientText: React.FC<GradientTextProps> = ({
  children,
  className = "",
}) => {
  return <span className={`gold-gradient-text ${className}`}>{children}</span>;
};

interface ShimmerBoxProps {
  children: React.ReactNode;
  className?: string;
}

export const ShimmerBox: React.FC<ShimmerBoxProps> = ({
  children,
  className = "",
}) => {
  return <div className={`shimmer-bg ${className}`}>{children}</div>;
};

interface GoldBorderProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const GoldBorder: React.FC<GoldBorderProps> = ({
  children,
  className = "",
  hover = false,
}) => {
  return (
    <div className={`gold-border ${hover ? "hover-lift" : ""} ${className}`}>
      {children}
    </div>
  );
};
